<!--最新事件-->
<template>
	<div>
		<p class="bigTitle">最新事件</p>
		<div class="custom-scrollbar hideBar">
			<table>
				<tr>
					<th>告警单位</th>
					<th>工单标题</th>
					<th>工单类型</th>
					<th>工单状况</th>
					<th>发起时间</th>
				</tr>
				<tr v-for="item in dataList">
					<td>{{item.unit}}</td>
					<td>{{item.orderTitle}}</td>
					<td>{{item.type}}</td>
					<td :style="getColor(item.state)">{{item.state}}</td>
					<td>{{item.createTime}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				dataList: []
			}
		},
		created() {},
		mounted() {
			var axios = require('axios')
			axios({
				url: "/static/中科泛在定制/看板/数据/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				eachObject(data.newstOrderList, (value, key) => {
					this[key] = value
				})
			})
		},
		destroyed() {},
		computed: {
			getColor() {
				return level => {
					var styleObject = {}
					switch (level) {
						case '处理中':
							styleObject.color = '#81FF64'
							break
						case '未处理':
							styleObject.color = '#FF954F'
							break
						case '已完成':
							styleObject.color = '#E15D68'
							break
					}
					return styleObject
				}
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	p.bigTitle {
		width: 100%;
		text-align: center;
		margin-top: 16px;
		color: #00C6FF;
		font-size: 18px;
		font-weight: 500;
	}

	.newstOrder .hideBar {
		height: calc(100% - 35px);
	}

	.newstOrder table {
		width: 100%;
	}

	.newstOrder th {
		color: #80BFEC;
		font-weight: 500;
		padding: 7px 11px;

	}

	.newstOrder td {
		color: white;
		padding: 7px 11px;
		text-align: center;
	}
</style>
